export let onlyView = {
    cart:'cart',// 购物车页面
    billsCP:'billsCP',// 订单页面
    generateOrderDetail:'generateOrderDetail',// 订单详情页面
    productDetail:'productDetail',// 产品详情页面
    packOrder:'packOrder',// 打包单页面
    addEditPackOrder:'addEditPackOrder',// 打包单详情页面
    giftOrder:'giftOrder',// 礼品单详情页面
    materialObject:'materialObject',//有实物退货单
    noMaterialObject:'noMaterialObject',//无实物退货单
    procurementDetail:'procurementDetail',// 采购需求管理详情
    procurementAlter:'procurementAlter',//采购需求变更
    procureHistoryView:'procureHistoryView',//采购历史详情
    transferDetail:'transferDetail',//调拨单详情
}


// WEBPACK FOOTER //
// ./src/utils/onlyView.js